import { useEffect, useState } from 'react'
import styles from './EditClaimCardPage.module.css'
import CustomModal from '../../components/UI/CustomModal/CustomModal'
import DeleteComponent from '../../components/DeleteComponent/DeleteComponent'
import Navbar from '../../components/Navbar/Navbar'
import IconTrashRed from '../../assets/icons/IconTrashRed.svg'
import HeaderForCard from '../../components/HeaderForCard/HeaderForCard'
import EditCardDescription from '../../components/EditCardDescription/EditCardDescription'
import EditClaimCardMainInformation from '../../components/EditClaimCardMainInformation/EditClaimCardMainInformation'
import {
  changeClaimDescription,
  changeClaimMainInformation,
  deleteCurrentClaim,
  getAllClaimsFromPlatforms,
  getCurrentClaim,
} from '../../redux/actions/claimsAction'
import { getClients } from '../../redux/actions/clientsAction'
import { RequestType } from '../../redux/actions/types'
import Loader from '../../components/UI/Loader/Loader'
import { useNavigate, useParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import PATH from '../../navigation/path'
import {
  createRuStatusValueForClaim,
  createStyleForStatusClaim,
} from '../../utils/createStatusForClaims'
import CustomButton from '../../components/UI/CustomButton/CustomButton'
import { useMediaQuery } from 'react-responsive'
import { useToast } from '../../context/ToastContext'
import { parseDateSafely } from '../../utils/date'

const EditClaimCardPage = () => {
  const [visible, setVisible] = useState<boolean>(false)
  const [firstReqId, setFirstReqId] = useState<number>(0)
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })
  const [yearsAndMonth, setYearsAndMonth] = useState('2025-02')
  const [monthNumber, setMonthNumber] = useState<number>(2)
  const { showSuccess, showError } = useToast()
  const { claimId } = useParams<{ claimId: string }>()
  const { isLoading, currentClaim } = useAppSelector((state) => state.claims)

  const { token, user } = useAppSelector((state) => state.auth)
  const { allClaimsFromPlaces } = useAppSelector((state) => state.claims)

  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const now = new Date()
  let month = now.getMonth()
  let year = now.getFullYear()

  useEffect(() => {
    setYearsAndMonth(`${year}-0${month + 1}`)
    setMonthNumber(month)
  }, [dispatch, month, year])

  useEffect(() => {
    if (currentClaim && currentClaim.startDate) {
      const startDate = parseDateSafely(currentClaim.startDate)
      const year = startDate.getFullYear()
      const month = startDate.getMonth() + 1
      setYearsAndMonth(`${year}-${month < 10 ? '0' + month : month}`)
    }
  }, [currentClaim])

  useEffect(() => {
    const items = allClaimsFromPlaces.filter((item) => item.id === currentClaim.place.id)

    const requests = items[0]
      ? items[0]?.requests.filter((item) => item.status === 'inAnticipation')
      : []

    if (requests.length > 0) {
      const overlappingRequests = requests.filter((request: RequestType) => {
        const requestStartDate = parseDateSafely(request.startDate)
        const requestEndDate = parseDateSafely(request.endDate)
        const currentClaimStartDate = parseDateSafely(currentClaim.startDate)
        const currentClaimEndDate = parseDateSafely(currentClaim.endDate)

        return requestStartDate <= currentClaimEndDate && requestEndDate >= currentClaimStartDate
      })

      if (overlappingRequests.length > 0) {
        const sortedRequests = overlappingRequests.sort((a: RequestType, b: RequestType) => {
          const dateA = new Date(a.createdAt).getTime()
          const dateB = new Date(b.createdAt).getTime()
          return dateA - dateB
        })

        setFirstReqId(sortedRequests[0].id)
      } else {
        setFirstReqId(0)
      }
    }
  }, [allClaimsFromPlaces, currentClaim])

  const onSubmitDescription = async (newDescription: string) => {
    const resultAction = await dispatch(
      changeClaimDescription({
        token,
        claimId,
        description: newDescription,
      }),
    )

    if (changeClaimDescription.rejected.match(resultAction)) {
      showError('Произошла ошибка при изменении описания')
    } else {
      showSuccess('Описание успешно изменено')
    }
  }

  const onResetHandler = () => {
    navigate(`${PATH.claimCardPage}${currentClaim.id}`)
  }

  const onDeletePlatformHandler = () => {
    setVisible(true)
  }

  useEffect(() => {
    const payload: any = {
      yearsAndMonth,
      token,
    }

    if (user.role !== 'superAdmin' && user.employee?.company?.id) {
      payload.companyId = String(user.employee.company.id)
    }

    dispatch(getAllClaimsFromPlatforms(payload))
  }, [dispatch, yearsAndMonth])

  const onDeleteClaim = async () => {
    const resultAction = await dispatch(
      deleteCurrentClaim({ claimId: String(currentClaim.id), token }),
    )

    if (deleteCurrentClaim.rejected.match(resultAction)) {
      showError('Произошла ошибка при удалении заявки')
    } else {
      setVisible(false)
      if (firstReqId > 0) {
        await dispatch(
          changeClaimMainInformation({
            token,
            claimId: String(firstReqId),
            payload: { status: 'inProgress' },
          }),
        )
        navigate(`${PATH.claimCardPage}${String(firstReqId)}`)
        showSuccess('Заявка успешно удалена, в очередь встала следующая заявка')
      } else {
        navigate(`${PATH.claimManagementPage}`)
        showSuccess('Заявка успешно удалена')
      }
    }
  }
  useEffect(() => {
    dispatch(getCurrentClaim({ claimId, token }))
  }, [dispatch, claimId])

  useEffect(() => {
    if (token) {
      dispatch(getClients({ token }) as any)
    }
  }, [dispatch, token])

  if (isLoading) {
    return <Loader />
  }

  return (
    <div className={styles.editClaimCardPage}>
      <CustomModal visible={visible} setVisible={setVisible}>
        <DeleteComponent
          title='Удаление заявки'
          description='Хотите удалить данную заявку ?'
          onCancelHandler={() => setVisible(false)}
          onDeleteHandler={onDeleteClaim}
        />
      </CustomModal>
      <Navbar />
      <div className={styles.headerBlock}>
        <HeaderForCard
          deleteButton={
            <CustomButton
              iconSrc={IconTrashRed}
              className={styles.deleteBtn}
              title={isMobile ? '' : 'Удалить заявку'}
              onClick={onDeletePlatformHandler}
            />
          }
          status={
            <div className={createStyleForStatusClaim(currentClaim.status)}>
              {createRuStatusValueForClaim(currentClaim.status)}
            </div>
          }
          title='Детали заявки'
          onRedirectHandler={onResetHandler}
        />
      </div>
      <div className={styles.content}>
        <EditClaimCardMainInformation claimData={currentClaim} />
        {currentClaim.description && (
          <EditCardDescription
            text={currentClaim.description ? currentClaim.description : ''}
            onSubmitHandler={onSubmitDescription}
            onResetHandler={onResetHandler}
          />
        )}
      </div>
    </div>
  )
}

export default EditClaimCardPage
